import React from "react";
import styled from "styled-components";

//
import Left from "./sections/left/Left";
import Right from "./sections/right/Right";

export default function Lesson() {
  return (
    <StyledLesson className="main x-h-md-100 overflow-hidden">
      <div className="lesson_wrap x-h-md-100">
        <div className="container-fluid mb-1 x-h-md-100">
          <div className="lesson_row row x-h-md-100">
            <Left />
            <Right />
          </div>
        </div>
      </div>
    </StyledLesson>
  );
}

const StyledLesson = styled.main`
  .lesson pre {
    border: 1px solid #dee2e6 !important;
  }
  .lesson {
    position: relative;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }
  .lesson_body {
    flex: 1 1 auto;
    padding: 1rem 1rem;
  }
  .lesson_breadcrumbs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 0;
  }
  .lesson_breadcrumbs_item a {
    color: #6c757d;
  }
  .lesson_breadcrumbs_item + .lesson_breadcrumbs_item:before {
    float: left;
    padding-right: 0.5rem;
    color: #6c757d;
    content: "→";
  }
  .lesson_breadcrumbs_item + .lesson_breadcrumbs_item {
    padding-left: 0.5rem;
  }
  .lesson_tabs {
    padding: 0;
    margin: 0;
    border-bottom: 1px solid #dee2e6;
    display: flex;
    justify-content: center;
  }
  .lesson_tab_item button {
    color: #6c757d !important;
    padding: 0.5rem 1rem;
    border: 1px solid transparent;
    cursor: pointer;
    font-size: 14px;
  }
  .lesson_tab_item button.active {
    background-color: #f5f7fb;
    border-color: #dee2e6 #dee2e6 #f5f7fb;
    border-top: 0;
  }
  .lesson_alert {
    padding: 1rem 1rem;
    margin-bottom: 1rem;
    font-size: 0.875em;
  }

  .lesson_article {
    margin-bottom: 1.5rem;
  }

  .lesson_content > .lesson_tab {
    display: none;
  }
  .lesson_content > .lesson_tab.active {
    display: block;
  }

  .lesson_bottom {
    color: #6c757d;
    font-size: 0.875em;
    padding-top: 1.5rem;
    border-top: 1px solid #c8c9ca;
  }
  .lesson_actions_row {
    display: flex;
  }
  .lesson_actions {
    display: flex;
    border-top: 1px solid #dee2e6;
  }

  .lesson_timer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .lesson_question {
    padding: 0.25rem;
    color: #6c757d;
  }
  #editor .form-floating > .form-control:focus,
  #editor .form-floating > .form-control:not(:placeholder-shown) {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }
  #editor .form-floating > .form-control,
  #editor .form-floating > .form-select {
    line-height: 1;
    height: calc(1rem + 2rem + 2px);
  }

  .lesson_info .lesson_content > .lesson_tab {
    height: calc(100vh - 106px);
    @media (max-width: 768px) {
      height: auto;
    }
  }

  .lesson_board .lesson_content > .lesson_tab {
    height: calc(100vh - 179px) !important;
    @media (max-width: 768px) {
      height: auto !important;
    }
  }

  @media screen and (max-width: 1690px) {
    .lesson_row {
      margin-left: -4px;
      margin-right: -4px;
    }
    .lesson_info,
    .lesson_board {
      padding-left: 4px;
      padding-right: 4px;
    }
  }
`;
